import type { SidebarState } from '../atoms/sidebar-state-atom';

const STORAGE_KEY = 'syncly-chat-sidebar-state';

const DEFAULT_SIDEBAR_STATE: SidebarState = {
  isOpen: true,
  width: 400, // Default width of 320px
  minWidth: 400,
  maxWidth: 600,
};

/**
 * Save sidebar state to localStorage
 */
export function saveSidebarState(state: SidebarState): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (error) {
    console.warn('Failed to save sidebar state to localStorage:', error);
  }
}

/**
 * Load sidebar state from localStorage with fallback to defaults
 */
export function loadSidebarState(): SidebarState {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      // Validate and merge with defaults to handle version changes
      return {
        ...DEFAULT_SIDEBAR_STATE,
        ...parsed,
        // Ensure width is within bounds
        width: Math.max(
          DEFAULT_SIDEBAR_STATE.minWidth,
          Math.min(DEFAULT_SIDEBAR_STATE.maxWidth, parsed.width || DEFAULT_SIDEBAR_STATE.width),
        ),
      };
    }
  } catch (error) {
    console.warn('Failed to load sidebar state from localStorage:', error);
  }
  return DEFAULT_SIDEBAR_STATE;
}

/**
 * Clear sidebar state from localStorage
 */
export function clearSidebarState(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.warn('Failed to clear sidebar state from localStorage:', error);
  }
}
